module.exports = __webpack_public_path__ + "static/img/29.a86c951.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/29.jpg
// module id = wz9c
// module chunks = 1